import type {Optional} from '@logistics-frontend/types'
import {useController, useFormContext} from '@yandex-delivery/form'

import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import type {Offer, Order} from '../../../shared/types'
import {useFetchOffersCalculate} from './use-fetch-offers-calculate'

export function useOfferList() {
  const {isOffersPending} = useFetchOffersCalculate()
  const {control, watch} = useFormContext<Order>()
  const {field, fieldState} = useController<Order>({control, name: 'offerFlow.offer'})
  const handleReachGoal = useFormUserEventHandler()

  const value: Optional<Offer> = field.value
  const vertical: Optional<string> = watch('offerFlow.vertical.name')
  const offers: Optional<Offer[]> = watch('__settings.__offers')?.filter(offer => offer.vertical === vertical)
  
  function changeHandler(offer: Offer) {
    if (!offer.disableReason) {
      return function _changeHandler() {
        field.onChange(offer)
        handleReachGoal(OrderEventGoal.OfferSelect)
      }
    }
  }

  return {
    errorMessage: fieldState.error?.message,
    isOffersPending,
    value,
    offers,
    changeHandler,
  } as const
}
